export default __webpack_public_path__ + "static/media/auth-graphics.8f380546.png";